module.exports = __webpack_public_path__ + "img/b1_01.ec76d3a2.jpg";